const v2 = {
  page_loader_errors: {
    failed_to_load_dependencies: 'Se ha producido un error al cargar el contenido de la página',
    unspecified: '¡Uy! Algo ha salido mal.',
    unauthorized: 'No autorizado.',
    unauthenticated: 'Se requiere autenticación.',
    no_domain_policy_access: 'Acceso denegado'
  },
  field_errors: {
    invalid_value: 'Valor no válido',
    required_value: 'Valor requerido',
    invalid_email: 'Dirección de correo electrónico no válida',
    email_domain_not_allowed: 'La dirección de correo electrónico debe pertenecer a un dominio que usted gestione.',
    outbound_email_ids_required: 'Se debe proporcionar la dirección de notificación de cuarentena del administrador.'
  }
}

export default v2
